import { html } from 'lit';
import componentStyles from './share.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import {classMap} from "lit/directives/class-map.js";

export default class Share extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      styleclass: { type: String },
      url: { type: String },
      title: { type: String },
      text: { type: String },
    };
  }

  constructor() {
    super();
    this.url = window.location.href
    this.text = document.title
    this.shareUrl = {}
    this.menuIsActive = false
  }

  firstUpdated() {
    this.shareUrl = {
      facebook: `https://www.facebook.com/share.php?u=${this.url}`,
      twitter: `https://twitter.com/intent/tweet?text=${this.text}&url=${this.url}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${this.url}`,
    }
    this.requestUpdate()
  }

  renderSocialItems() {
    const socialItemsTemplate = []
    Object.entries(this.shareUrl).forEach(([socialNetwork, socialShareUrl]) => {
      socialItemsTemplate.push(html`
        <li class="share__item-wrapper">
          <a href="${socialShareUrl}"
             target="_blank"
             class="share__item share__item--${socialNetwork}">
            <hf-icon name="${socialNetwork}" class="share__item-icon"></hf-icon>
          </a>
        </li>
      `)
    });

    return socialItemsTemplate
  }

  closeMenu() {
    this.menuIsActive = false
    document.activeElement.blur()
    this.requestUpdate()
  }

  toggleActive(event) {
    event.preventDefault()
    this.menuIsActive = !this.menuIsActive
    this.requestUpdate()
  }

  render() {
    return html`
      <div class="${classMap({
        'share': true,
        [`share--${this.styleclass}`]: !!this.styleclass,
      })}">
        <div
          class="${classMap({
          'share__button': true,
          'active': this.menuIsActive
        })}">
          <a
            class="share__button-link"
            @click="${this.toggleActive}"
            href="#"
            aria-expanded="${this.menuIsActive}">
            <div>Share</div>
            <hf-icon name="share" class="share__icon"></hf-icon>
          </a>
          <ul class="${classMap({
            'share__menu': true,
            'active': this.menuIsActive
          })}">
            ${this.renderSocialItems()}
          </ul>
          <div
            @click="${this.closeMenu}"
            class="${classMap({
              'share__overlay': true,
              'active': this.menuIsActive
            })}"></div>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-share', Share);
